import {
  AttachFileOutlined,
  Clear as ClearIcon,
  CloseRounded,
  ContentCopy as CopyIcon,
  Send as SendIcon,
} from "@mui/icons-material";
import {
  Alert,
  Box,
  Button,
  Card,
  Chip,
  CircularProgress,
  Collapse,
  Container,
  Divider,
  IconButton,
  InputAdornment,
  Paper,
  TextareaAutosize,
  TextField,
  Typography,
} from "@mui/material";
import { useCallback, useMemo, useRef, useState } from "react";
// import Screen from "../components/layout/Screen";
import { Navigate } from "react-router-dom";
import LoadingFallback from "../../components/LoadingFallback";
import SelectInput from "../../components/inputs/SelectInput";
import SelectToggleInput from "../../components/inputs/SelectToggleInput";
import InputWrapper from "../../components/inputs/shared/InputWrapper";
import Flx from "../../components/layout/Flx";
import Screen from "../../components/layout/Screen";
import ScreenContent from "../../components/layout/ScreenContent";
import Htag from "../../components/typography/Htag";
import Txt from "../../components/typography/Txt";
import { useAxiosHook } from "../../hooks/useAxiosHook";
import { useReduxHook } from "../../hooks/useReduxHook";
import FileUploadField from "../../components/inputs/FileUploadField";
import { isEmpty } from "lodash";
import AgGridTableWrapper from "../../components/agGrid/AgGridTableWrapper";
import { AgGridReact } from "ag-grid-react";
import { parse } from "date-fns";

const EndpointTesterRoute = () => {
  const {
    axiosGetRequest,
    axiosPostRequest,
    axiosGetIsLoading,
    axiosPostIsLoading,
  } = useAxiosHook();

  const { isDevUser, user } = useReduxHook();

  const [method, setMethod] = useState("GET");
  const [url, setUrl] = useState("");
  const [domain, setDomain] = useState("default");
  const [payload, setPayload] = useState("{}");
  const [headers, setHeaders] = useState("{}");
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);
  const [showAdvanced, setShowAdvanced] = useState(true);
  const [responseTime, setResponseTime] = useState(null);
  const [includeQueryParams, setIncludeQueryParams] = useState(false);
  const [containsFiles, setContainsFiles] = useState(false);
  const [files, setFiles] = useState([]);

  const [formData, setFormData] = useState(false);
  // const [responseType, setResponseType] = useState("json");
  const [isFile, setIsFile] = useState(false);

  const isLoading = axiosGetIsLoading || axiosPostIsLoading;

  const handleSendRequest = async () => {
    setResponse(null);
    setError(null);
    const startTime = Date.now();

    try {
      // Validate JSON inputs
      let parsedPayload = {};
      let parsedHeaders = {};

      if (method === "POST" && payload) {
        try {
          parsedPayload = JSON.parse(payload);
        } catch (e) {
          setError({ message: "Invalid JSON in payload", details: e.message });
          return;
        }
      }

      if (headers && headers !== "{}") {
        try {
          parsedHeaders = JSON.parse(headers);
        } catch (e) {
          setError({ message: "Invalid JSON in headers", details: e.message });
          return;
        }
      }

      if (formData && !isEmpty(parsedPayload)) {
        console.log("Form Data Payload:", parsedPayload);
        parsedPayload = { ...parsedPayload, uploadMetadata: files };
      }
      const requestParams = {
        name: `API Test - ${method} ${url}`,
        path: url,
        type: domain, // For GET requests
        domain: domain, // For POST requests
        // responseType: responseType,
        onSuccessFn: (responseData, fullResponse) => {
          const endTime = Date.now();
          setResponseTime(endTime - startTime);
          setResponse(responseData);
          console.log("Full Response:", fullResponse);
        },
        onFailFn: (err) => {
          const endTime = Date.now();
          setResponseTime(endTime - startTime);
          setError({
            message: err.message || "Request failed",
            details: err.response?.data || err,
          });
        },
        hideFailMsg: true, // We'll handle error display ourselves
      };

      if (method === "GET") {
        console.log("GET Request Params:", {
          ...requestParams,
          isFile,
          // fileDownload:isFile,
          openInNewTab: false,
        });
        // return;
        await axiosGetRequest({
          ...requestParams,
          isFile,
          // fileDownload:isFile,
          openInNewTab: false,
        });
      } else {
        console.log("POST Request Params:", {
          ...requestParams,
          payload: parsedPayload,
          headers: parsedHeaders,
          includeQueryParams,
          formData: isEmpty(parsedPayload) && !isEmpty(files) ? true : formData,
          files: isEmpty(parsedPayload) ? files : null,
          // fileDownload:isFile,
          // responseType,
        });
        // return;
        await axiosPostRequest({
          ...requestParams,
          payload: parsedPayload,
          headers: parsedHeaders,
          includeQueryParams,
          formData,
          files: isFile,
          // fileDownload:isFile,
          // responseType,
        });
      }
    } catch (err) {
      setError({
        message: "Unexpected error",
        details: err.message,
      });
    }
  };

  const handleCopyResponse = () => {
    if (response) {
      navigator.clipboard.writeText(JSON.stringify(response, null, 2));
    }
  };

  const handleFilesAdded = (newFiles) => {
    setFiles((prevFiles) => [...prevFiles, ...newFiles]);
  };

  const handleClearAll = () => {
    setUrl("");
    setPayload("{}");
    setHeaders("{}");
    setResponse(null);
    setError(null);
    setResponseTime(null);
  };

  const formatJson = (jsonString) => {
    try {
      const parsed = JSON.parse(jsonString);
      return JSON.stringify(parsed, null, 2);
    } catch {
      return jsonString;
    }
  };

  const handleFormatPayload = () => {
    setPayload(formatJson(payload));
  };

  const handleFormatHeaders = () => {
    setHeaders(formatJson(headers));
  };

  // Example payloads for quick testing
  if (!user) {
    return (
      <Flx center sx={{ p: 5 }}>
        <LoadingFallback />
      </Flx>
    );
  }

  if (user && !isDevUser) {
    return <Navigate to="/" replace />;
  }

  return (
    <Screen>
      <ScreenContent>
        <Container maxWidth="lg">
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mt: 2,
              mb: 3,
            }}
          >
            <Htag>API Tester</Htag>
            <Button
              variant="outlined"
              color="secondary"
              startIcon={<ClearIcon />}
              onClick={handleClearAll}
            >
              Clear All
            </Button>
          </Box>

          {/* Request Configuration */}
          <Card sx={{ p: 3, mb: 3 }}>
            <Htag variant="h2" sx={{ fontWeight: 700 }}>
              Request Configuration
            </Htag>

            <Flx sx={{ display: "flex", gap: 3, mt: 3, mb: 2 }}>
              <InputWrapper label="Method" sx={{ flexShrink: 0 }}>
                <SelectToggleInput
                  value={method}
                  label="Method"
                  onChange={(e) => setMethod(e)}
                  options={["GET", "POST"]}
                />
              </InputWrapper>

              <InputWrapper label="Domain" sx={{ flexShrink: 0 }}>
                <SelectInput
                  value={domain}
                  onChange={(e) => setDomain(e)}
                  options={[
                    {
                      label: "Resilender",
                      value: "default",
                    },
                    {
                      label: "Error Testing",
                      value: "errorTesting",
                    },
                    {
                      label: "Resfin",
                      value: "resfin",
                    },
                  ]}
                />
              </InputWrapper>
              <InputWrapper label="URL Path" sx={{ flexGrow: 1 }}>
                <TextField
                  fullWidth
                  placeholder="e.g., underwriting/loan/123"
                  value={url}
                  onChange={(e) => setUrl(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Txt>/</Txt>
                      </InputAdornment>
                    ),
                  }}
                  helperText="Enter the path without the domain"
                />
              </InputWrapper>
            </Flx>

            {method === "POST" && (
              <>
                <CopyPasteBox
                  label="Payload (JSON):"
                  error={error}
                  value={payload}
                  onChange={setPayload}
                  onFormat={handleFormatPayload}
                />
                {/* <Box sx={{ mb: 2, position: "relative" }}>
                  <Txt bold>Payload (JSON):</Txt>
                  <TextareaAutosize
                    error={error}
                    value={payload}
                    placeholder="Paste your fields array here (JSON format)..."
                    onChange={(e) => setPayload(e?.target.value)}
                    multiline
                    minRows={1}
                    style={{
                      marginTop: "8px",
                      border: "1px solid rgba(0, 0, 0, 0.23)",
                      borderRadius: "4px",
                      padding: "10px",
                      width: "100%",
                      maxWidth: "100%",
                      minWidth: "100%",
                      minHeight: "100px",
                      fontSize: "11px",
                      maxHeight: "800px",
                      height: "200px",
                    }}
                    maxRows={6}
                    size="medium"
                  />

                  <Button
                    size="small"
                    sx={{ position: "absolute", right: 16, top: 16 }}
                    onClick={handleFormatPayload}
                  >
                    Format JSON
                  </Button>
                </Box> */}
              </>
            )}

            <Box sx={{ mb: 2 }}>
              <Txt bold>Request Options:</Txt>
              <Box sx={{ display: "flex", gap: 2, mt: 1, flexWrap: "wrap" }}>
                <Chip
                  label="Is File Download"
                  color={isFile ? "primary" : "default"}
                  onClick={() => setIsFile(!isFile)}
                  variant={isFile ? "filled" : "outlined"}
                />
                <Chip
                  label="Show File Upload"
                  color={containsFiles ? "primary" : "default"}
                  onClick={() => setContainsFiles(!containsFiles)}
                  variant={containsFiles ? "filled" : "outlined"}
                />
                <Chip
                  label="Form Data"
                  color={formData ? "primary" : "default"}
                  onClick={() => setFormData(!formData)}
                  variant={formData ? "filled" : "outlined"}
                />
                <Chip
                  label="Include Query Params"
                  color={includeQueryParams ? "primary" : "default"}
                  onClick={() => setIncludeQueryParams(!includeQueryParams)}
                  variant={includeQueryParams ? "filled" : "outlined"}
                />

                {/* {isFile && (
                  <Chip
                    label="Auto Download"
                    color={fileDownload ? "primary" : "default"}
                    onClick={() => setFileDownload(!fileDownload)}
                    variant={fileDownload ? "filled" : "outlined"}
                  />
                )} */}
              </Box>
              {containsFiles && (
                <Flx column sx={{ mt: 3 }}>
                  <Txt sx={{ fontSize: "11px" }}>Upload Files:</Txt>
                  <FileUploadField onFilesAdded={handleFilesAdded} />
                  <UploadedFilesTable files={files} setFiles={setFiles} />
                </Flx>
              )}
            </Box>
            {/* Advanced Options */}

            <Box sx={{ mt: 4 }}>
              {/* <Txt bold>Response Type</Txt> */}
              <Collapse in={showAdvanced}>
                {/* <Box sx={{ display: "flex", gap: 2, mb: 6, mt: 1 }}>
                  <SelectToggleInput
                    value={responseType}
                    label="Response Type"
                    onChange={(e) => setResponseType(e)}
                    options={["json", "blob", "text", "arraybuffer"]}
                  />
                </Box> */}

                <CopyPasteBox
                  label="Custom Headers (JSON)"
                  helperText="Additional headers to include in the request"
                  onFormat={handleFormatHeaders}
                  onChange={setHeaders}
                  value={headers}
                  // error={error}
                />
                {/* <Box sx={{ position: "relative", mb: 2 }}>
                  <TextField
                    fullWidth
                    multiline
                    rows={3}
                    // label="Custom Headers (JSON)"
                    value={headers}
                    onChange={(e) => setHeaders(e.target.value)}
                    helperText="Additional headers to include in the request"
                  />
                  <Button
                    size="small"
                    sx={{ position: "absolute", right: 8, top: 8 }}
                    onClick={handleFormatHeaders}
                  >
                    Format JSON
                  </Button>
                </Box> */}
              </Collapse>
            </Box>

            <Button
              variant="contained"
              color="primary"
              size="large"
              startIcon={
                isLoading ? (
                  <CircularProgress size={20} color="inherit" />
                ) : (
                  <SendIcon />
                )
              }
              onClick={handleSendRequest}
              disabled={!url || isLoading}
              sx={{ mt: 2 }}
              fullWidth
            >
              {isLoading ? "Sending Request..." : "Send Request"}
            </Button>
          </Card>

          {/* Response Section */}
          {(response || error) && (
            <Card sx={{ p: 3 }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mb: 2,
                }}
              >
                <Typography variant="h6">
                  Response{" "}
                  {responseTime && (
                    <Chip
                      label={`${responseTime}ms`}
                      size="small"
                      color="info"
                      sx={{ ml: 2 }}
                    />
                  )}
                </Typography>
                {response && (
                  <IconButton
                    onClick={handleCopyResponse}
                    size="small"
                    title="Copy Response"
                  >
                    <CopyIcon />
                  </IconButton>
                )}
              </Box>

              <Divider sx={{ mb: 2 }} />

              {error && (
                <Alert severity="error" sx={{ mb: 2 }}>
                  <Typography variant="subtitle2" gutterBottom>
                    {error.message}
                  </Typography>
                  {error.details && (
                    <Paper sx={{ p: 2, mt: 1, bgcolor: "grey.100" }}>
                      <pre
                        style={{
                          margin: 0,
                          overflow: "auto",
                          fontSize: "0.85rem",
                          fontFamily: "monospace",
                          whiteSpace: "pre-wrap",
                          wordBreak: "break-word",
                        }}
                      >
                        {typeof error.details === "string"
                          ? error.details
                          : JSON.stringify(error.details, null, 2)}
                      </pre>
                    </Paper>
                  )}
                </Alert>
              )}

              {response && (
                <Paper
                  sx={{
                    p: 2,
                    bgcolor: "grey.50",
                    maxHeight: "600px",
                    overflow: "auto",
                  }}
                >
                  <pre
                    style={{
                      margin: 0,
                      fontSize: "0.85rem",
                      fontFamily: "monospace",
                      whiteSpace: "pre-wrap",
                      wordBreak: "break-word",
                    }}
                  >
                    {typeof response === "string"
                      ? response
                      : JSON.stringify(response, null, 2)}
                  </pre>
                </Paper>
              )}
            </Card>
          )}
        </Container>
      </ScreenContent>
    </Screen>
  );
};

const CopyPasteBox = ({
  label,
  error,
  value,
  onChange,
  onFormat,
  helperText,
}) => {
  return (
    <Box sx={{ mb: 2, position: "relative" }}>
      <Txt bold>{label}</Txt>
      <TextareaAutosize
        error={error}
        value={value}
        placeholder="Paste your fields array here (JSON format)..."
        onChange={(e) => onChange(e?.target.value)}
        multiline
        helperText={helperText}
        minRows={1}
        style={{
          marginTop: "8px",
          border: "1px solid rgba(0, 0, 0, 0.23)",
          borderRadius: "4px",
          padding: "10px",
          width: "100%",
          maxWidth: "100%",
          minWidth: "100%",
          minHeight: "100px",
          fontSize: "11px",
          maxHeight: "800px",
          height: "100px",
        }}
        maxRows={6}
        size="medium"
      />

      <Button
        size="small"
        sx={{ position: "absolute", right: 8, top: 36 }}
        onClick={onFormat}
      >
        Format JSON
      </Button>
    </Box>
  );
};

const UploadedFilesTable = ({ files, setFiles }) => {
  const ref = useRef();

  const modalContentRef = useRef(null);

  const columnDefs = useMemo(
    () => [
      {
        headerName: "Filename",
        field: "file_display_name",
        flex: 1,
        minWidth: 250,
        cellEditor: "agTextCellEditor",
        editable: true,
        // checkbox: true,
        cellStyle: {
          display: "flex",
          alignItems: "center",
          gap: "6px",
          paddingLeft: "8px",
        },
        cellRenderer: (params) => {
          return (
            <>
              <AttachFileOutlined className="thin" sx={{ fontSize: 16 }} />

              {params.value}
            </>
          );
        },
      },

      {
        width: 42,
        cellStyle: {
          paddingRight: 0,
          paddingLeft: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        },
        field: "delete",
        cellRenderer: (params) => {
          return (
            <IconButton sx={{ p: 0.4 }} size="small">
              <CloseRounded className="thin" />
            </IconButton>
          );
        },
      },
    ],
    []
  );

  const handleCellValueChanged = useCallback(
    (params) => {
      const { colDef, data, newValue } = params;

      // Create a copy of the data to update
      const updatedData = { ...data };

      // If the user changes the filename
      if (colDef.field === "file_display_name") {
        const originalExtension = data.name.split(".").pop().toLowerCase();
        const newValueWithoutExt = newValue.replace(/\.[^/.]+$/, "");
        updatedData.file_display_name = `${newValueWithoutExt}.${originalExtension}`;
      }

      // If the user changes docGroup
      if (colDef.field === "docGroup") {
        updatedData.docGroup = newValue;
        // Clear docType when docGroup changes
        updatedData.docType = "";
      }

      // If the user changes docType
      if (colDef.field === "docType") {
        updatedData.docType = newValue;
      }

      // Update the parent files state
      setFiles((prev) =>
        prev.map((item) => (item.id === data.id ? updatedData : item))
      );

      setTimeout(() => {
        if (ref.current && ref.current.api) {
          ref.current.api.refreshCells();
        }
      }, 0);
    },
    [setFiles]
  );

  const onCellClicked = useCallback(
    (params) => {
      const { colDef, data } = params;

      if (colDef.field === "delete") {
        setFiles((prev) => prev.filter((item) => item.id !== data.id));
      }
    },
    [setFiles]
  );

  if (isEmpty(files)) {
    return null;
  }

  return (
    <Box
      sx={{
        ".ag-header": {
          border: "none !important",
        },
      }}
    >
      <AgGridTableWrapper
        simpleTable
        suppressMinHeightWhenPopulated={files}
        sx={{
          border: "1px solid #e0e0e0",
          overflow: "hidden",
          borderRadius: 1,
        }}
      >
        <AgGridReact
          ref={ref}
          rowData={files}
          columnDefs={columnDefs}
          singleClickEdit
          onCellClicked={onCellClicked}
          domLayout={"autoHeight"}
          headerHeight={0}
          onCellValueChanged={handleCellValueChanged}
          stopEditingWhenCellsLoseFocus
          popupParent={modalContentRef.current}
          // getRowId={(params) => params.data.id}
          // onSelectionChanged={handleRowSelectionChange}
          // rowSelection={{
          //   mode: "multiRow",
          // }}
        />
      </AgGridTableWrapper>
    </Box>
  );
};

export default EndpointTesterRoute;
